(function ($, window, document) {
	const $win = $(window);
    const $doc = $(document);
	const $html = $('html');
	const $header = $('.header');

	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}
	});

	/**
	 * Handler to trigger "widthResize" event when the width of the element changes.
	 * // iOs device window resize helper
	 */
	$.event.special.widthResize = {
		setup: function() {
			const $this = $(this);
			$this.data('currentWidth', $this.width());

			$this.on('resize.widthResize', function() {
				const newWidth = $this.width();
				const prevWidth = $this.data('currentWidth');

				if (newWidth !== prevWidth) {
					$this.data('currentWidth', newWidth).trigger('widthResize');
				}
			});
		},
		teardown: function() {
			$(this).off('resize.widthResize');
		}
	};

	/**
	 * Initialize selectric plugin on a set of elements
	 *
	 * @param {Object} element
	 * @returns {Void}
	 */
	function initSelectric(element) {
		if ( !$(element).length || !$(element).is('select') ) {
			return;
		}

		$(element).selectric({
			disableOnMobile: false,
			nativeOnMobile: false,
			onOpen: function() {
				$('.selectric-input').blur();

				const $fixer = $(this).closest('.selectric-wrapper')
					.find('.selectric-items');

				$fixer.fadeOut();
				$fixer.stop(true, true).hide().fadeIn();
				$fixer.attr('tabindex', 0);
			},
			onClose: function() {
				const $fixer = $(this).closest('.selectric-wrapper')
					.find('.selectric-items');

				$fixer.fadeIn();
				$fixer.stop(true, true).show().fadeOut();
				$fixer.attr('tabindex', -1);
			},
			onChange: function() {
				const $wrapper = $(this).closest('.selectric-wrapper');
				const $values = $wrapper.find('.selectric-hide-select option');

				$values.parent()
					.find('option:selected')
					.prop('selected', false);

				$($values.get($wrapper.find('.selected').index()))
					.prop('selected', true)
				.parent()
					.trigger('change');

				$wrapper.addClass('is-selected');
			}
		});
	}

	/**
	 * Set CSS Variable.
	 * @param {String} name
	 * @param {Number} value
	 * @param {String} unit
	 * @param {jQuery} $element
	 * @returns {Void}
	*/
	function setCSSVariable(name, value, unit = '', $element = $html) {
		$element.css(`--${name}`, `${value}${unit}`);
	}

	/**
	 * Init Selectric.
	 */
	initSelectric($('select'));

	/**
	 * Handle css variables.
	 */
	setCSSVariable('header-h', $header.outerHeight(), 'px');
	setCSSVariable('bar-height', $header.find('.header__bar').outerHeight(), 'px');

	$win.on('resize scroll', function() {
		setCSSVariable('header-h', $header.outerHeight(), 'px');
		setCSSVariable('bar-height', $header.find('.header__bar').outerHeight(), 'px');
	});

	$('.js-pay-with-option').click(function(e){
		var $this = $(this),
			option = $this.data('option');

		if(!$('.payment-option--' + option).hasClass('active')){
			$('.payment-option.active').removeClass('active').hide()
			$('.payment-option--' + option).addClass('active').fadeIn(200)
		}
	});
	if ($('.js-pay-with-option').length > 0) {
		$('.js-pay-with-option:checked').trigger('click');
	}

	$('.form--pay-with-flywire').submit(function(e){
		e.preventDefault();
		if($(this).find('[name="country"]').val() == 'AU') {
			alert('Flywire is only available for non Australian users, please pay with Visa/Mastercard')
		}
		else {
			var $form = $(this),
				$submit = $form.find('[type="submit"]'),
				$applicationTermsConditions = $('input[name="applicationTermsConditions"]'),
				extraFormData = '';

			if ($applicationTermsConditions.length) {
				$applicationTermsConditions.parents('.form__row').find('.error').html('');
				if($applicationTermsConditions.is(':checked'))
					extraFormData = '&applicationTermsConditions=' + $applicationTermsConditions.val();
			}

			$submit.prop('disabled',true)
			$form.find('.error').html('');
			$.ajax({
				type: 'POST',
				url: $form.attr('action'),
				data: $form.serialize() + extraFormData,
				dataType: 'json',
				success: function(config) {
					$submit.prop('disabled',false)
					config.onInvalidInput = function (errors) { console.error(errors); };
					window.FlywirePayment.initiate(config).render();
				},
				error: function(xhr) {
					$submit.prop('disabled',false)
					if( xhr.status === 422 ) {
						var data = $.parseJSON(xhr.responseText);
						$.each(data.errors, function (key, value) {
							if (key == 'applicationTermsConditions') {
								// console.log($applicationTermsConditions)
								$applicationTermsConditions.parents('.form__row').find('.error').html(value);
							}
							else {
								$form.find('[name="' + key + '"]' ).parents('.form__row').find('.error').html(value);
							}
						});
					}
					else if(xhr.status === 409) {
						location.reload()
					}
				}
			});
		}
		return false;
	});

	/**
	 * Stripe two-step payment flow supporting cards and wallet methods
	 * (WeChat Pay, Alipay).
	 *
	 * Card flow (step 1):
	 *   elements.submit() → createConfirmationToken() → POST token to preview
	 *   endpoint → backend creates PaymentIntent for the base amount (card
	 *   surcharges abolished) → show step 2 summary → confirmPayment() with confirmation_token.
	 *
	 * Wallet flow (step 1):
	 *   elements.submit() → POST payment_method_type to preview endpoint →
	 *   backend calculates surcharge from config directly → show step 2 summary
	 *   → confirmPayment() with elements (triggers QR/redirect).
	 */
	var $stripeForm = $('.form--pay-with-stripe');
	if ($stripeForm.length > 0) {
		var $stripeWrapper         = $('.payment-option--stripe');
		var stripePublishableKey   = $stripeWrapper.data('publishable-key');
		var stripeConnectedAccount = $stripeWrapper.data('connected-account');
		var stripeAmount           = parseInt($stripeWrapper.data('amount'), 10);
		var stripePreviewUrl       = $stripeWrapper.data('preview-url');
		var stripeReturnUrl        = $stripeWrapper.data('return-url');

		// Payment methods enabled via STRIPE_PAYMENT_METHODS in .env
		// e.g. "card,wechat_pay,alipay" → ['card', 'wechat_pay', 'alipay']
		var stripePaymentMethods = ($stripeWrapper.data('payment-methods') || 'card')
			.split(',')
			.map(function (m) { return m.trim(); })
			.filter(function (m) { return m.length > 0; });

		var stripeOptions = {};
		if (stripeConnectedAccount) {
			stripeOptions.stripeAccount = stripeConnectedAccount;
		}
		var stripe   = Stripe(stripePublishableKey, stripeOptions);
		var elements = stripe.elements({
			mode:                  'payment',
			amount:                stripeAmount,
			currency:              'aud',
			paymentMethodCreation: 'manual',
			paymentMethodTypes:    stripePaymentMethods,
		});
		var paymentElement = elements.create('payment');
		paymentElement.mount('#stripe-payment-element');

		// Wallet methods (non-card) require a different confirm path.
		var stripeWalletTypes = stripePaymentMethods.filter(function (m) { return m !== 'card'; });

		// Tracks whichever method the user has selected in the Payment Element.
		var selectedPaymentType = 'card';
		paymentElement.on('change', function (event) {
			if (event.value && event.value.type) {
				selectedPaymentType = event.value.type;
			}
		});

		// clientSecret returned from the preview endpoint (both flows).
		var stripeClientSecret = null;
		// Confirmation token ID — set for cards, null for wallets.
		var stripeConfirmationTokenId = null;

		/**
		 * POST to the preview endpoint and, on success, populate and show step 2.
		 */
		function stripeDoPreview($submit, $errors, postData) {
			$.ajax({
				type:     'POST',
				url:      stripePreviewUrl,
				data:     postData,
				dataType: 'json',
				success: function (data) {
					stripeClientSecret = data.clientSecret;
					$('#stripe-summary-base').text('AUD $' + data.baseAmount);
					$('#stripe-summary-surcharge').text('AUD $' + data.surchargeAmount);
					// Only WeChat Pay / Alipay attract a surcharge (card surcharges abolished).
					$('#stripe-summary-surcharge-row').toggle(parseFloat(data.surchargeAmount) > 0);
					$('#stripe-summary-total').text('AUD $' + data.totalAmount);
					$('#stripe-step-1').hide();
					$('#stripe-step-2').show();
					$submit.prop('disabled', false).text('Review Payment');
				},
				error: function (xhr) {
					var msg = 'Unable to calculate payment summary. Please try again.';
					if (xhr.responseJSON && xhr.responseJSON.error) {
						msg = xhr.responseJSON.error;
					}
					$errors.text(msg).show();
					$submit.prop('disabled', false).text('Review Payment');
				},
			});
		}

		// ── Step 1: "Review Payment" ──────────────────────────────────────────
		$stripeForm.on('submit', function (e) {
			e.preventDefault();

			var $form   = $(this);
			var $submit = $form.find('#stripe-submit');
			var $errors = $form.find('#stripe-errors');
			$errors.hide().text('');

			// For agent bookings the terms checkbox lives in a separate form.
			// Copy its value into a hidden field so the server receives it.
			var $termsCheckbox = $('input[name="applicationTermsConditions"]').not($form.find('*'));
			if ($termsCheckbox.length) {
				if (!$termsCheckbox.is(':checked')) {
					$errors.text('You must accept the terms and conditions before paying.').show();
					setTimeout(function () { $submit.prop('disabled', false); }, 100);
					return false;
				}
				$form.find('#stripe-terms-hidden').remove();
				$form.append('<input type="hidden" id="stripe-terms-hidden" name="applicationTermsConditions" value="' + $termsCheckbox.val() + '">');
			}

			$submit.prop('disabled', true).text('Processing…');
			stripeConfirmationTokenId = null;

			var isWallet = stripeWalletTypes.indexOf(selectedPaymentType) !== -1;
			var csrfToken = $('meta[name="csrf-token"]').attr('content');

			elements.submit().then(function (submitResult) {
				if (submitResult.error) {
					$errors.text(submitResult.error.message).show();
					$submit.prop('disabled', false).text('Review Payment');
					return;
				}

				if (isWallet) {
					// Wallet: skip the confirmation token and POST the method type
					// directly so the backend can look up the fixed surcharge rate.
					stripeDoPreview($submit, $errors, {
						_token:              csrfToken,
						payment_method_type: selectedPaymentType,
					});
				} else {
					// Card: create a confirmation token, used to confirm the payment
					// in step 2. No surcharge applies to card payments.
					stripe.createConfirmationToken({ elements: elements }).then(function (result) {
						if (result.error) {
							$errors.text(result.error.message).show();
							$submit.prop('disabled', false).text('Review Payment');
							return;
						}
						stripeConfirmationTokenId = result.confirmationToken.id;
						stripeDoPreview($submit, $errors, {
							_token:                    csrfToken,
							stripe_confirmation_token: stripeConfirmationTokenId,
						});
					});
				}
			});

			return false;
		});

		// ── Step 2: "Confirm & Pay" ───────────────────────────────────────────
		$(document).on('click', '#stripe-confirm', function () {
			var $btn    = $(this);
			var $errors = $('#stripe-step-2-errors');
			$errors.hide().text('');
			$btn.prop('disabled', true).text('Processing…');

			var confirmOptions;
			if (stripeConfirmationTokenId) {
				// Card: confirm with the stored confirmation token.
				confirmOptions = {
					clientSecret: stripeClientSecret,
					confirmParams: {
						confirmation_token: stripeConfirmationTokenId,
						return_url:         stripeReturnUrl,
					},
				};
			} else {
				// Wallet: pass elements so Stripe can handle the QR / redirect.
				confirmOptions = {
					clientSecret: stripeClientSecret,
					elements:     elements,
					confirmParams: {
						return_url: stripeReturnUrl,
					},
				};
			}

			stripe.confirmPayment(confirmOptions).then(function (result) {
				// Only reaches here on error; success always redirects to return_url.
				if (result.error) {
					$errors.text(result.error.message).show();
					$btn.prop('disabled', false).text('Confirm Payment');
				}
			});
		});

		// ── Step 2: "Back" link ───────────────────────────────────────────────
		$(document).on('click', '#stripe-back', function (e) {
			e.preventDefault();
			$('#stripe-step-2').hide();
			$('#stripe-step-1').show();
		});
	}

	function parseDate(input, format) {
		if (typeof input == 'undefined') return false;
		format = format || 'yyyy-mm-dd'; // default format
		var parts = input.match(/(\d+)/g),
		i = 0, fmt = {};

		// extract date-part indexes from the format
		format.replace(/(yy|yyyy|dd|mm)/g, function(part) {
			fmt[part] = i++;
		});

		if (parts[fmt['yyyy']]) {
			year = parts[fmt['yyyy']];
		}
		else {
			year = parts[fmt['yy']]
		}

		// console.log({ date: { year: year, fmt_mm: fmt['mm'], fmt_dd: fmt['dd'], parts_fmt_mm: (parts[fmt['mm']] - 1), parts_fmt_dd: parts[fmt['dd']] }});
		return new Date(year, parts[fmt['mm']]-1, parts[fmt['dd']]);
	}

	function dateDiffInYears(dateold, datenew) {
		var ynew = datenew.getFullYear();
		var mnew = datenew.getMonth();
		var dnew = datenew.getDate();
		var yold = dateold.getFullYear();
		var mold = dateold.getMonth();
		var dold = dateold.getDate();
		var diff = ynew - yold;
		if (mold > mnew) diff--;
		else {
			if (mold == mnew) {
				if (dold > dnew) diff--;
			}
		}
		return diff;
	}

	$('#birth_date').change(function() {
		// console.log('#birth_date trigger change');
		if ($(this).val() != '') {
			// console.log('birthday', $(this).val());
			var compareDate;
			var birthday = parseDate($(this).val(), 'yy-mm-dd'),
				// roomContractDateStart = parseDate($('input[name="roomContractDateStart"]').val(), 'yy-mm-dd'),
				checkDate = new Date().toISOString().split('T')[0],
				age = false;

			if ($('input[name="roomContractDateStart"]').length > 0) {
				checkDate = $('input[name="roomContractDateStart"]').val();
			}

			compareDate = parseDate(checkDate, 'yy-mm-dd');
			if (birthday !== false && compareDate !== false) {
				age = dateDiffInYears(birthday, compareDate);
			}
			// console.log({ birthday: birthday, checkDate: checkDate, compareDate: compareDate, age: age });

			if (age !== false && age < 16) {
				$('#under_18').slideUp();
				$('#under_16').slideDown();
				$('#register-box input[type="submit"]').fadeOut();
				alert('You are under 16, and not allowed to register.');
			}
			else {
				$('#under_16').slideUp();
				$('#register-box input[type="submit"]').fadeIn();
				if (age < 18) {
					$('#under_18').slideDown();
				}
				else {
					$('#under_18').slideUp();
				}
			}
		}
	}).trigger('change');

	function escapeString( string ) {
		return string.replace( /(:|\.|\[|\]|,|=|@)/g, "\\$1" );
	}

	$('form').on('change','.js-show-field-if-value',function(){
		var showIfVal = $(this).data('show-if-value'),
			fieldName = $(this).data('show-field-name'),
			otherField = $('[name="' + escapeString(fieldName) + '"]'),
			otherFieldParent = otherField.parents('.form__row');

		// console.log($(this).val() ,showIfVal);
		// console.log(otherField);
		if ($(this).val() == showIfVal) otherFieldParent.slideDown();
		else otherFieldParent.slideUp();
	});

	$('form').on('change','.js-show-other-field',function(){
		var fieldName = $(this).data('other'),
			otherField = $('[name="' + escapeString(fieldName) + '"]'),
			otherFieldParent = otherField.parents('.form__row');
		// console.log('js show other field');
		// console.log($(this).val().toLowerCase());

		if ($(this).val().toLowerCase() == 'other') otherFieldParent.slideDown();
		else otherFieldParent.slideUp();
	});

	$('form').on('submit', function () {
		let $submitButton = $(this).find('.form__actions button[type=submit]');
		if ($submitButton.length > 0) {
			$submitButton.prop('disabled', true);
		}
		return true;
	});

	$('.js-apply-button-switch').on('click', function () {
		$('#lc, #rc').addClass('d-none');
		const thisHref = $(this).attr('href');

		if ($('.js-apply-button-switch.btn--grey').length > 0) {
			$('.js-apply-button-switch.btn--grey').removeClass('btn--grey');
		}
		$(this).addClass('btn--grey');

		if ($(thisHref).length > 0) {
			$(thisHref).removeClass('d-none');
		}
		return false;
	});

    /**
     * Toggle accordion hidden content
     */
    $doc.on('click', '.js-accordion .accordion__head', function (e) {
        e.preventDefault();

        const $this = $(this);

        $this.toggleClass('is-active').siblings().removeClass('is-active');

        $this
            .next()
            .stop(true, true)
            .slideToggle()
            .closest('.accordion__section')
            .toggleClass('is-open');
    });

})(jQuery, window, document);
